<script>
    export let helperText;
    export let label;
    export let placeholder;
    export let name;
    export let required = false;
    export let disabled = false;
    export let value = "";

    export let onKeyup;
    export let onChange;
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .disabled {
        background-color: #e1e1e1;
        cursor: not-allowed;

        label,
        input {
            cursor: not-allowed;
        }
    }

    .input-container {
        @include input-container;
    }

    label {
        @include input-label;
    }

    textarea {
        font-size: var(--font-regular);
        font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
            Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
        height: 130px;
        resize: vertical;
        border: none;
        opacity: 0.8;

        &:invalid {
            border: none;
            box-shadow: none;
        }
    }

    p {
        font-size: var(--font-small);
        opacity: 0.3;
    }

    ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        opacity: 0.3;
    }
    ::-moz-placeholder {
        /* Firefox 19+ */
        opacity: 0.3;
    }
    :-ms-input-placeholder {
        /* IE 10+ */
        opacity: 0.3;
    }
    :-moz-placeholder {
        /* Firefox 18- */
        opacity: 0.3;
    }
</style>

<div class="input-container" class:disabled>
    <label for={name}>{label}</label>
    <textarea
        {placeholder}
        {name}
        {required}
        maxlength="350"
        bind:value
        {disabled}
        on:keyup={onKeyup}
        on:change={onChange} />
</div>

{#if helperText}
    <p>{helperText}</p>
{/if}
